import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/** Estado vacío único de la app; una acción opcional se proyecta como contenido. */
@Component({
    selector: 'app-empty-state',
    standalone: true,
    imports: [],
    templateUrl: './empty-state.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
    /** Clase(s) de PrimeIcons. */
    readonly icon = input<string>('pi pi-inbox');
    readonly title = input<string>('Sin datos');
    readonly description = input<string>('');
    /** Mensaje flotante compacto, con el icono separado de la etiqueta. */
    readonly appearance = input<'default' | 'overlay'>('default');

    protected readonly iconClass = computed(() => `${this.icon()} rbi-empty-state__icon`);
}
